export default "__VITE_ASSET__DrKsmrPY__"